import React from "react";
import { useTrack } from "@/Logigate/hooks/useTrack";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Condominio {
    id: number;
    nome: string;
    slug: string;
}

interface CondominioSeletorProps {
    condominios: Condominio[];
    condominioSelecionadoId: number;
    onCondominioChange?: (condominio: Condominio, menu: any[]) => void;
}

/** O condomínio do grupo «Gestão Condominial» (a escolha fica guardada neste aparelho). */
export default function CondominioSeletor({ condominios, condominioSelecionadoId, onCondominioChange }: CondominioSeletorProps) {
    const { track } = useTrack("condominio");

    return (
        <SeletorDoGrupo
            itens={condominios}
            selecionadoId={condominioSelecionadoId}
            chaveGuardada="condominio_selecionado_id"
            caminhoMenu={(id) => `/condominio/menu/${id}`}
            icone="mdi:office-building"
            rotulo="Condomínio"
            placeholder="Escolher o condomínio"
            nadaEncontrado="Nenhum condomínio encontrado"
            textoErro="Não foi possível carregar o menu do condomínio. Tenta de novo."
            aoEscolher={(condominio) => track("clicou", "condominio_selecionar_condominio", { md: { condominio_id: condominio.id, condominio_nome: condominio.nome } })}
            onTrocar={onCondominioChange}
        />
    );
}
